import { z } from "zod";
import { LocalTime } from "./time.js";
/**
 * The briefing script skeleton (§1.1). Already redacted by the brain before it
 * lands here — strings in this object are safe to speak aloud and to log at the
 * configured redaction level. The agent improvises delivery; this is the spine.
 */
/** The dynamic verification content (§4). Task-echo is the default mode. */
export const TaskEcho = z.object({
    /** What the agent states, e.g. "First on deck: ESG load-in, leave by 9:20." */
    prompt: z.string().min(1),
    /** The question that demands the content back, e.g. "What time are you out?" */
    challenge: z.string().min(1),
    /**
     * Canonical answer used to grade the echo, e.g. "9:20". The agent accepts
     * paraphrase; this is the fact that must be present. Grunts/silence fail.
     */
    expectedAnswer: z.string().min(1),
    /** Extra accepted forms, e.g. ["nine twenty", "twenty past nine"]. */
    acceptablePhrases: z.array(z.string()).default([]),
});
/** The single concrete physical next step the call always ends on (§6.2). */
export const FirstAction = z.object({
    text: z.string().min(1).describe('e.g. "Feet on floor, water, shower."'),
});
/** The first out-of-house event with its computed leave-by time. */
export const FirstEvent = z.object({
    /** Redacted label, e.g. "ESG load-in" or "Your 10 AM". */
    label: z.string().min(1),
    startsAt: LocalTime,
    leaveBy: LocalTime.nullable().describe("null if not an out-of-house event"),
});
export const ScriptSkeleton = z.object({
    /** Greeting line; persona delivers it. */
    greeting: z.string().min(1),
    /** Weather one-liner, if available. */
    weather: z.string().nullable().default(null),
    /** Shape of the day: 3–5 beats max (§6.1), already redacted. */
    beats: z.array(z.string()).max(5),
    /** First event with leave-by, or null on an empty morning. */
    firstEvent: FirstEvent.nullable().default(null),
    /** Anything needing prep before noon. */
    prepBeforeNoon: z.array(z.string()).default([]),
    /** The dynamic dismissal challenge. */
    taskEcho: TaskEcho,
    /** The closing one-action. */
    firstAction: FirstAction,
});
//# sourceMappingURL=script.js.map